export default __webpack_public_path__ + "static/media/aotu2.a83db92f.mp4";